
import { useEffect, useState } from "react";
import { Logo, LogoExpanded } from '../../assets/images/index';
import {
  Overview,
  OverviewSelected,
  Schedule,
  ScheduleSelected,
  Records,
  RecordsSelected,
  Orders,
  OrdersSelected,
  Logout,
  Logs,
  LogsSelected,
  TripsByBoat,
  TripsByBoatSelected,
  Salary,
  SalarySelected,
  Chart,
  ChartSelected,
  FinishedProductOrdersIcon,
  FinishedProductOrdersSelectedIcon,
  StockMenuIcon,
  StockMenuSelectedIcon,
  ReleaseNotesIcon,
  ReleaseNotesSelectedIcon,
  FinancialAccountsIcon,
  FinancialAccountsSelectedIcon
} from '../../assets/icons/index';
import {
  Nav,
  NavIcon,
  NavLink,
  NavLinkActive,
  NavMenu,
  LogoArea,
  LogoImg,
  LogoImgExpanded
} from './styles';
import LocalStorageService, { clearAuthenticatedCache } from '../../services/storage';
import Tooltip from "@mui/material/Tooltip";

function getCurrentURL() {
  return window.location.href;
}

export function Menu() {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [, setSelectedPage] = useState(0);
  const LogoToShow = menuExpanded ? LogoExpanded : Logo;
  const LogoImgToShow = menuExpanded ? LogoImgExpanded : LogoImg;
  const localStorageService = LocalStorageService();
  const userInfo = localStorageService.getUserInfo();
  const userRole = userInfo?.user_role;
  const url = getCurrentURL();

  useEffect(() => {
    function updateAuthentication(event) {
      if (event.type === "storage" && event.key === "token") {
        clearAuthenticatedCache();
        window.location.reload();
        return;
      }

      setIsAuthenticated(!!localStorage.getItem('token'));
    }

    window.addEventListener("tokenActive", updateAuthentication);
    window.addEventListener("storage", updateAuthentication);

    return () => {
      window.removeEventListener("tokenActive", updateAuthentication);
      window.removeEventListener("storage", updateAuthentication);
    };
  }, []);

  function handleLogout() {
    localStorageService.logout();
    setIsAuthenticated(false);
    setSelectedPage(pages.length);
  }

  const pages = [
    {
      label: 'Pedidos',
      icon: Orders,
      iconSelected: OrdersSelected,
      path: '/orders',
      allowedRoles: ['adm', 'write', 'view']
    },
    {
      label: 'Resumo Geral',
      icon: Overview,
      iconSelected: OverviewSelected,
      path: '/overview',
      allowedRoles: ['adm']
    },
    {
      label: 'Resumo Conta Correntes',
      icon: Chart,
      iconSelected: ChartSelected,
      path: '/financial-overview',
      allowedRoles: ['adm']
    },

    {
      label: 'Viagens por barco',
      icon: TripsByBoat,
      iconSelected: TripsByBoatSelected,
      path: '/tripsbyboat',
      allowedRoles: ['adm', 'write', 'calc-prod']
    },
    {
      label: 'Programação',
      icon: Schedule,
      iconSelected: ScheduleSelected,
      path: '/schedule',
      allowedRoles: ['adm']
    },
    {
      label: 'Contas Financeiras',
      icon: FinancialAccountsIcon,
      iconSelected: FinancialAccountsSelectedIcon,
      path: '/financial-accounts',
      allowedRoles: ['adm', 'write', 'view', 'calc-prod', 'salary', 'app_access']
    },
    {
      label: 'Cadastros',
      icon: Records,
      iconSelected: RecordsSelected,
      path: '/records',
      allowedRoles: ['adm', 'write', 'view']
    },
    {
      label: 'Estoque',
      icon: StockMenuIcon,
      iconSelected: StockMenuSelectedIcon,
      path: '/stock-options',
      allowedRoles: ['adm', 'write', 'view']
    },
    {
      label: 'Remuneração',
      icon: Salary,
      iconSelected: SalarySelected,
      path: '/salary',
      allowedRoles: ['adm', 'write', 'calc-prod', 'salary']
    },
    {
      label: 'Histórico',
      icon: Logs,
      iconSelected: LogsSelected,
      path: '/logs',
      allowedRoles: ['adm', 'write', 'view']
    },
    {
      label: 'Pedidos Produto Acabado',
      icon: FinishedProductOrdersIcon,
      iconSelected: FinishedProductOrdersSelectedIcon,
      path: '/finished-product-orders',
      allowedRoles: ['adm', 'write', 'view']
    },
    {
      label: 'Sobre',
      icon: ReleaseNotesIcon,
      iconSelected: ReleaseNotesSelectedIcon,
      path: '/about',
      allowedRoles: ['adm', 'write', 'view', 'calc-prod', 'salary', 'app_access']
    }
  ];

  function MenuItem({ page, index }) {
    if (url.includes(page.path)) {
      return (
        <Tooltip title={menuExpanded ? '' : page.label}>
          <NavLinkActive to={page.path} onClick={() => setSelectedPage(index)} >
            <NavIcon src={page.iconSelected} alt={page.label}></NavIcon>
            {menuExpanded && page.label}
          </NavLinkActive>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={menuExpanded ? '' : page.label}>
          <NavLink to={page.path} onClick={() => setSelectedPage(index)} >
            <NavIcon src={page.icon} alt={page.label}></NavIcon>
            {menuExpanded && page.label}
          </NavLink>
        </Tooltip>
      );
    }
  }

  function LogoutItem() {
    if (menuExpanded) {
      return (
        <NavLink to={'/'} onClick={handleLogout} key="Logout" >
          <NavIcon src={Logout} alt="logout"></NavIcon>
          Sair
        </NavLink>
      );
    } else {
      return (
        <Tooltip title="Sair">
          <NavLink to={'/'} onClick={handleLogout} key="Logout" >
            <NavIcon src={Logout} alt="logout"></NavIcon>
          </NavLink>
        </Tooltip>
      );
    }
  }

  return (
    <Nav style={{ display: isAuthenticated ? 'flex' : 'none' }} expanded={menuExpanded} >
      <LogoArea>
        <LogoImgToShow src={LogoToShow} onClick={() => setMenuExpanded(!menuExpanded)} alt='logo' />
      </LogoArea>
      <NavMenu>
        {
          pages.map((page, index) => {
            const hasPermission = page.allowedRoles.includes(userRole);

            if (hasPermission) {
              return (
                <MenuItem page={page} index={index} key={page.label}></MenuItem>
              );
            } else {
              return null;
            }
          })
        }
      </NavMenu>
      <LogoutItem />
    </Nav>
  );
};
